import { render, staticRenderFns } from "./v-statistics.vue?vue&type=template&id=3ceabefe&scoped=true"
import script from "./v-statistics.vue?vue&type=script&lang=js"
export * from "./v-statistics.vue?vue&type=script&lang=js"
import style0 from "./v-statistics.vue?vue&type=style&index=0&id=3ceabefe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceabefe",
  null
  
)

export default component.exports